/**
 * Custom Post — Like, Share e Comment engagement.
 *
 * Busca um CSRF token fresco em /csrf-token antes de cada POST,
 * garantindo compatibilidade com páginas servidas via HTML cache.
 */

export default (() => {
  const likeBtn = document.getElementById('cp-like-btn')
  const commentForm = document.getElementById('cp-comment-form')
  const shareBtns = document.querySelectorAll('.cp-share-btn')

  if (!likeBtn && !commentForm && shareBtns.length === 0) return

  /**
   * Obtém um CSRF token fresco do servidor.
   *
   * @returns {Promise<string>}
   */
  const fetchCsrfToken = () =>
    fetch('/csrf-token', { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((data) => data.token)

  /* ── Like ─────────────────────────────────────────────────────────────── */
  if (likeBtn) {
    likeBtn.addEventListener('click', function () {
      if (likeBtn.disabled) return
      likeBtn.disabled = true

      fetchCsrfToken()
        .then((csrfToken) =>
          fetch(likeBtn.dataset.likeUrl, {
            method: 'POST',
            headers: {
              'X-CSRF-TOKEN': csrfToken,
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ _et: likeBtn.dataset.et }),
          })
        )
        .then((r) => r.json())
        .then((data) => {
          if (data.likes !== undefined) {
            document.getElementById('cp-likes-count').textContent = data.likes
            document.getElementById('cp-likes-badge').textContent = data.likes
            likeBtn.classList.replace('btn-outline-secondary', 'btn-primary')
            likeBtn.querySelector('i').className = 'bx bxs-like me-2 lead'
          }
        })
        .catch(() => {
          likeBtn.disabled = false
        })
    })
  }

  /* ── Share ────────────────────────────────────────────────────────────── */
  shareBtns.forEach((btn) => {
    btn.addEventListener('click', function () {
      fetchCsrfToken()
        .then((csrfToken) =>
          fetch(btn.dataset.shareUrl, {
            method: 'POST',
            headers: {
              'X-CSRF-TOKEN': csrfToken,
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ _et: btn.dataset.et }),
          })
        )
        .then((r) => r.json())
        .then((data) => {
          if (data.shares !== undefined) {
            document.getElementById('cp-shares-count').textContent = data.shares
          }
        })
        .catch(() => {})
    })
  })

  /* ── Comentários ──────────────────────────────────────────────────────── */
  if (!commentForm) return

  const parentInput = document.getElementById('cp-parent-id')
  const replyIndicator = document.getElementById('cp-reply-indicator')
  const replyAuthor = document.getElementById('cp-reply-author')
  const cancelReply = document.getElementById('cp-cancel-reply')
  const commentAlert = document.getElementById('cp-comment-alert')
  const submitBtn = document.getElementById('cp-submit-btn')

  document.querySelectorAll('.cp-reply-trigger').forEach((btn) => {
    btn.addEventListener('click', function () {
      parentInput.value = btn.dataset.parent
      replyAuthor.textContent = btn.dataset.author
      replyIndicator.classList.remove('d-none')
      document.getElementById('cp-body').focus()
      document
        .getElementById('cp-comment-form-wrap')
        .scrollIntoView({ behavior: 'smooth' })
    })
  })

  if (cancelReply) {
    cancelReply.addEventListener('click', function () {
      parentInput.value = ''
      replyIndicator.classList.add('d-none')
    })
  }

  commentForm.addEventListener('submit', function (e) {
    e.preventDefault()
    if (!commentForm.checkValidity()) {
      commentForm.classList.add('was-validated')
      return
    }

    submitBtn.disabled = true
    submitBtn.textContent = 'Enviando...'
    commentAlert.className = 'alert d-none'

    const formData = new FormData(commentForm)
    const body = {}
    formData.forEach((v, k) => {
      body[k] = v
    })

    const commentUrl = commentForm.dataset.commentUrl

    fetchCsrfToken()
      .then((csrfToken) =>
        fetch(commentUrl, {
          method: 'POST',
          headers: {
            'X-CSRF-TOKEN': csrfToken,
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(body),
        })
      )
      .then((r) => r.json().then((d) => ({ ok: r.ok, data: d })))
      .then((res) => {
        if (res.ok) {
          commentAlert.className = 'alert alert-success'
          commentAlert.textContent =
            res.data.message ?? 'Comentário enviado com sucesso!'
          commentForm.reset()
          parentInput.value = ''
          replyIndicator?.classList.add('d-none')
          commentForm.classList.remove('was-validated')
        } else {
          const errors = res.data.errors
            ? Object.values(res.data.errors).flat().join(' ')
            : res.data.message ?? 'Erro ao enviar.'
          commentAlert.className = 'alert alert-danger'
          commentAlert.textContent = errors
        }
      })
      .catch(() => {
        commentAlert.className = 'alert alert-danger'
        commentAlert.textContent = 'Erro de conexão. Tente novamente.'
      })
      .finally(() => {
        submitBtn.disabled = false
        submitBtn.textContent = 'Enviar comentário'
      })
  })
})()
